import { createReducer, on, Action } from '@ngrx/store';
import * as admin from './admin.action';
import { IAdminTemplateResult } from 'src/app/feature/admin/models/admin';
import * as fromAdmin from './admin-permission.adapter';
import * as fromSuperAdmin from './superadmin.adapter';

import { IAdminPermissionsResult } from 'src/app/feature/admin/models/permission';
import { AppPermissions } from 'src/app/feature/admin/helper/constants';
import { SiteConfigurationAdapter, SiteConfigurationState, intialSiteConfigurationState } from './admin.adapter';

export const initialState: IAdminTemplateResult = {};

const reducer = createReducer(
  initialState,
  on(admin.SuccessGetAdminDetailsApiAction, (state, { complianceDetails }) => state = complianceDetails),
  on(admin.ErrorGetAdminDetailsApiAction, (state, error) => ({ ...state, error })),
);

export function AdminTemplatesReducer(state: IAdminTemplateResult | undefined, action: Action) {
  return reducer(state, action);
}

export const initialStateSuperAdminPermissions: IAdminPermissionsResult = {};
export const initialStateAdminPermissions: IAdminPermissionsResult = {};

const adminPermissionReducer = createReducer(
  fromAdmin.intialAdminPermissionsState,
  on(admin.GetAdminPermissionsApiAction, (state) => {
    const obj: fromAdmin.AdminPermissionsState = {
      ...state,
      isLoaded: false,
      serverError: false
    };
    return state = obj;
  }),
  on(admin.SuccessGetAdminPermissionsApiAction, (state, { permissions }) => {
    if (permissions.message === undefined) {
      const AdminTemplates = permissions.payload.filter(item =>
        item.permissions.some(permission =>
          (permission.id === AppPermissions.ConfigureComplianceReadiness.id ||
            permission.id === AppPermissions.BuildReports.id ||
            permission.id === AppPermissions.Proxy.id ||
            permission.id === AppPermissions.FirstApprover.id ||
            permission.id === AppPermissions.SecondApprover.id ||
            permission.id === AppPermissions.Security.id)));
      return fromAdmin.AdminPermissionsAdapter.setAll(AdminTemplates, state);
    }
    return fromAdmin.AdminPermissionsAdapter.setAll([], state);
  }),
  on(admin.SuccessGetAdminPermissionsApiAction, (state, { permissions }) => {
    const obj: fromAdmin.AdminPermissionsState = {
      ...state,
      isLoaded: true,
      serverError: false
    };
    return state = obj;
  }),
  on(admin.ErrorGetAdminPermissionsApiAction, (state, error) => {
    const obj: fromAdmin.AdminPermissionsState = {
      ...state,
      isLoaded: true,
      serverError: true
    };
    return state = obj;
  }),
  on(admin.UpdateOneAdminPermissionApiAction, (state, { permission }) => fromAdmin.AdminPermissionsAdapter.updateOne(permission, state)),
  on(admin.RemoveAllAdminPermissionApiAction, (state) => fromAdmin.AdminPermissionsAdapter.removeAll(state)),
  on(admin.DeleteOneAdminPermissionApiAction, (state, { permissionId }) => {
    return fromAdmin.AdminPermissionsAdapter.removeOne(permissionId, state);
  })

);

export function AdminPermissionReducer(state: fromAdmin.AdminPermissionsState | undefined, action: Action) {
  return adminPermissionReducer(state, action);
}

const superAdminPermissionReducer = createReducer(
  fromSuperAdmin.intialAdminPermissionsState,
  on(admin.GetSuperAdminPermissionsApiAction, (state) => {
    const obj: fromSuperAdmin.SuperAdminPermissionsState = {
      ...state,
      isLoaded: false,
      serverError: false
    };
    return state = obj;
  }),
  on(admin.SuccessGetSuperAdminPermissionsApiAction, (state, { permissions }) => {
    if (permissions.message === undefined) {
      return fromSuperAdmin.SuperAdminPermissionsAdapter.setAll(permissions.payload, state);
    }
    return fromSuperAdmin.SuperAdminPermissionsAdapter.setAll([], state);
  }),
  on(admin.SuccessGetSuperAdminPermissionsApiAction, (state, { permissions }) => {
    const obj: fromSuperAdmin.SuperAdminPermissionsState = {
      ...state,
      isLoaded: true
    };
    return state = obj;
  }),
  on(admin.ErrorGetSuperAdminPermissionsApiAction, (state, error) => {
    const obj: fromSuperAdmin.SuperAdminPermissionsState = {
      ...state,
      isLoaded: true,
      serverError: true
    };
    return state = obj;
  }),
  on(admin.UpdateOneSuperAdminPermissionApiAction, (state, { permission }) => fromSuperAdmin.SuperAdminPermissionsAdapter.updateOne(permission, state)),
  on(admin.RemoveAllSuperAdminPermissionApiAction, (state) => fromSuperAdmin.SuperAdminPermissionsAdapter.removeAll(state)),
  on(admin.DeleteOneSuperAdminPermissionApiAction, (state, { permissionId }) => {
    return fromSuperAdmin.SuperAdminPermissionsAdapter.removeOne(permissionId, state);
  })
);

export function SuperAdminPermissionReducer(state: fromSuperAdmin.SuperAdminPermissionsState | undefined, action: Action) {
  return superAdminPermissionReducer(state, action);
}

const adminSiteConfigurationsReducer = createReducer(
  intialSiteConfigurationState,
  on(admin.GetAdminSiteConfigurationsApiAction, (state) => {
    return { ...state, isLoaded: false };
  }),
  on(admin.SuccessGetAdminSiteConfigurationsApiAction, (state, { configurations }) => SiteConfigurationAdapter.setAll(configurations, state)),
  on(admin.SuccessGetAdminSiteConfigurationsApiAction, (state, { configurations }) => {
    return { ...state, isLoaded: true };
  }),
  on(admin.RemoveAllAdminSiteConfigurationsApiAction, (state) => SiteConfigurationAdapter.removeAll(state)),
  on(admin.UpdateAdminSiteConfigurationsAction, (state, { configuration }) => SiteConfigurationAdapter.updateOne(configuration, state)),
  on(admin.ErrorGetAdminSiteConfigurationsApiAction, (state, error) => ({ ...state, error })),
);

export function AdminSiteConfigurationsReducer(state: SiteConfigurationState | undefined, action: Action) {
  return adminSiteConfigurationsReducer(state, action);
}
